import { Box, Tooltip, Chip } from '@mui/material';
import { t } from 'i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { Colors } from 'src/shared/components/styles/colors';
import { EventParticipant } from '../models/eventParticipant';

type EventParticipantsSendEmailRecipientsProps = {
  selectedEventParticipants: EventParticipant[];
};

export const EventParticipantsSendEmailRecipients = (props: EventParticipantsSendEmailRecipientsProps) => {
  const { selectedEventParticipants } = props;

  const showName = (ep: EventParticipant) => {
    const name = `${ep.firstName} ${ep.lastName}`;
    return name || ep.email;
  };

  return (
    <FormFieldset legend={t('event:sendParticipantMessageWithCounter', { count: selectedEventParticipants.length })}>
      <Box p={1} sx={{ maxHeight: '6rem', overflowY: 'auto', display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {selectedEventParticipants.map((item) => {
          return (
            <Tooltip title={item.email} key={item.id}>
              <Chip label={showName(item)} sx={{ height: '1.5rem', borderRadius: 1, color: '#fff', backgroundColor: Colors.ChipColors.Blue }} />
            </Tooltip>
          );
        })}
      </Box>
    </FormFieldset>
  );
};
